/* fh-read.js - lesemal (2026-08-22, fase 2)
   1) Lokal nav glir inn naar tittelen er scrollet forbi (IntersectionObserver, fail-safe).
   2) Tabeller i innhold faar en scroll-wrapper saa de aldri sprenger mobilbredden.
   3) Gamle rte-oppskrifter: en <ol> rett etter en "Fremgangsmaate"-overskrift faar steg-stil.
   4) Kapitler: id="kap-N" paa h2 nr N, scrollspy som markerer aktivt kapittel i chips + innholdsliste.
   5) FAQ (fha__faq-item) blir trekkspill; innholdslista lukkes som standard paa mobil.
   Alt i try/catch - feiler noe, vises siden som ren Liquid-render. */
(function () {
  'use strict';
  function init() {
    var roots = document.querySelectorAll('[data-fhr]');
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, function (root) {
      try { localNav(root); } catch (e) {}
      try { wrapTables(root); } catch (e) {}
      try { recipeSteps(root); } catch (e) {}
      try { servings(root); } catch (e) {}
      try { chapters(root); } catch (e) {}
      try { faq(root); } catch (e) {}
      try { tocMobile(root); } catch (e) {}
    });
  }

  function headerBottom() {
    var header = document.querySelector('.theme__header');
    return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
  }

  function localNav(root) {
    var nav = root.querySelector('.fhr__localnav');
    var sentinel = root.querySelector('[data-fhr-sentinel]') || root.querySelector('h1');
    if (!nav || !sentinel || !('IntersectionObserver' in window)) return;
    // Broadcast-headeren ligger i en fixed <header-component>: legg lokal nav rett under den,
    // og foelg med hvis headeren skulle skjule seg (rAF-throttlet).
    var header = document.querySelector('.theme__header');
    var wrap = header && header.closest('header-component');
    var fixed = wrap && /fixed|sticky/.test(getComputedStyle(wrap).position);
    var ticking = false;
    function measure() {
      ticking = false;
      if (!header || !fixed) return;
      root.style.setProperty('--fhr-nav-top', headerBottom() + 'px');
    }
    if (fixed) {
      measure();
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }, { passive: true });
      window.addEventListener('resize', measure);
    }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      root.classList.toggle('fhr--nav-on', passed);
      nav.setAttribute('aria-hidden', passed ? 'false' : 'true');
      var links = nav.querySelectorAll('a');
      Array.prototype.forEach.call(links, function (a) { if (passed) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });
    io.observe(sentinel);
  }

  function wrapTables(root) {
    var tables = root.querySelectorAll('.fhr__body table');
    Array.prototype.forEach.call(tables, function (t) {
      if (t.closest('.fhr__scroll') || t.closest('.fha__table-wrapper')) return;
      var w = document.createElement('div');
      w.className = 'fhr__scroll';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    scrollHints(root);
  }

  /* 2026-10-03: skroll-hint + kantfade naar en tabell er bredere enn spalten */
  function scrollHints(root) {
    var wraps = root.querySelectorAll('.fhr__body .fhr__scroll, .fhr__body .fha__table-wrapper');
    var all = [];
    Array.prototype.forEach.call(wraps, function (w) {
      if (w.getAttribute('data-fhr-hint')) return;
      w.setAttribute('data-fhr-hint', '1');
      if (!w.classList.contains('fhr__scroll')) w.classList.add('fhr__scroll');
      var hint = document.createElement('p');
      hint.className = 'fhr__scroll-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Sveip sideveis for å se hele tabellen';
      hint.hidden = true;
      w.parentNode.insertBefore(hint, w);
      var check = function () {
        var more = w.scrollWidth > w.clientWidth + 2;
        w.classList.toggle('fhr__scroll--more', more);
        w.classList.toggle('fhr__scroll--end', w.scrollLeft + w.clientWidth >= w.scrollWidth - 4);
        hint.hidden = !more;
      };
      w.addEventListener('scroll', check, { passive: true });
      all.push(check);
      check();
    });
    if (all.length) {
      var runAll = function () { all.forEach(function (f) { f(); }); };
      window.addEventListener('resize', runAll, { passive: true });
      window.addEventListener('load', runAll);
    }
  }

  function recipeSteps(root) {
    var body = root.querySelector('.fhr__body');
    if (!body || body.querySelector('.fha__recipe-card')) return;
    var heads = body.querySelectorAll('h2, h3');
    Array.prototype.forEach.call(heads, function (h) {
      if (!/fremgangsm|slik gj|steg for steg|slik lager du/i.test(h.textContent || '')) return;
      var n = h.nextElementSibling;
      while (n && n.tagName === 'P') n = n.nextElementSibling;
      if (n && n.tagName === 'OL' && !n.classList.contains('fhr__steps')) n.classList.add('fhr__steps');
    });
  }

  /* Porsjonsvelger (v2 2026-08-27): skalerer mengder i .fha__ingredients per oppskriftskort.
     Basis = "Porsjoner: N" i recipe-meta, fallback recipeYield fra Recipe-JSON-LD.
     Skalerer ALDRI tall inne i produktlenker, etter "à"/"#", eller foran °/%/min/timer. */
  function servings(root) {
    var cards = root.querySelectorAll('.fhr__body .fha__recipe-card');
    if (!cards.length) return;
    var ldYield = null;
    try {
      Array.prototype.forEach.call(document.querySelectorAll('script[type="application/ld+json"]'), function (s) {
        if (ldYield) return;
        try {
          var d = JSON.parse(s.textContent);
          (Array.isArray(d) ? d : [d]).forEach(function (o) {
            if (o && /Recipe/.test(String(o['@type'])) && o.recipeYield && !ldYield) {
              var m = String(o.recipeYield).match(/\d+/);
              if (m) ldYield = parseInt(m[0], 10);
            }
          });
        } catch (e) {}
      });
    } catch (e) {}

    var UNITS = /^(g|kg|dl|cl|ml|l|ss|ts|stk|fedd|never|bunt|pk|pakke|boks|glass)\b/i;

    function markQtys(ul) {
      var walker = document.createTreeWalker(ul, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (node.parentElement && (node.parentElement.closest('a') || node.parentElement.closest('.fhr__qty'))) return;
        var text = node.nodeValue;
        var re = /(\d+(?:[.,]\d+)?|[½¼¾])(?:(\s*[-–]\s*)(\d+(?:[.,]\d+)?|[½¼¾]))?/g;
        var m, parts = [], last = 0, changed = false;
        while ((m = re.exec(text))) {
          var before = text.slice(0, m.index);
          var after = text.slice(m.index + m[0].length);
          var prev = before.replace(/\s+$/, '').slice(-2);
          var skip = /[à#\/\d]$/.test(prev) ||               /* etter "à", "#", "/" eller sifferkontekst */
                     /^\s*(?:\/|°|%|min\b|time|t\b|cm\b|mm\b|år\b)/i.test(after);
          if (skip) continue;
          var unitM = after.match(/^\s*([a-zæøå]+)/i);
          var unit = unitM && UNITS.test(unitM[1]) ? unitM[1].toLowerCase() : '';
          parts.push({ start: m.index, end: m.index + m[0].length, lo: m[1], sep: m[2] || '', hi: m[3] || '', unit: unit });
          changed = true;
        }
        if (!changed) return;
        var frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (p.start > last) frag.appendChild(document.createTextNode(text.slice(last, p.start)));
          var span = document.createElement('span');
          span.className = 'fhr__qty';
          span.setAttribute('data-lo', String(parseNum(p.lo)));
          if (p.hi) { span.setAttribute('data-hi', String(parseNum(p.hi))); span.setAttribute('data-sep', p.sep); }
          span.setAttribute('data-unit', p.unit);
          span.textContent = text.slice(p.start, p.end);
          frag.appendChild(span);
          last = p.end;
        });
        if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
    }

    function parseNum(s) {
      if (s === '½') return 0.5;
      if (s === '¼') return 0.25;
      if (s === '¾') return 0.75;
      return parseFloat(String(s).replace(',', '.'));
    }

    function fmt(v, unit) {
      if (unit === 'g') { var r = v >= 100 ? Math.round(v / 10) * 10 : v >= 20 ? Math.round(v / 5) * 5 : Math.round(v); return String(r); }
      if (/^(kg|l|dl|cl|ml|ss|ts)$/.test(unit)) { var d = Math.round(v * 10) / 10; return String(d).replace('.', ','); }
      var h = Math.round(v * 2) / 2;
      if (h < 0.5) h = 0.5;
      if (h % 1 === 0) return String(h);
      return (h >= 1 ? Math.floor(h) + ' ' : '') + '½';
    }

    Array.prototype.forEach.call(cards, function (card) {
      var ing = card.querySelector('.fha__ingredients');
      if (!ing || card.querySelector('.fhr__servings')) return;
      var ul = ing.querySelector('ul');
      if (!ul) return;
      var base = null, pill = null;
      Array.prototype.forEach.call(card.querySelectorAll('.fha__recipe-meta span'), function (sp) {
        var m = (sp.textContent || '').match(/porsjon\w*\s*:?\s*(\d+)/i);
        if (m) { base = parseInt(m[1], 10); pill = sp; }
      });
      if (!base) base = ldYield;
      if (!base || base < 1 || base > 16) return;
      markQtys(ul);
      if (!ul.querySelector('.fhr__qty')) return;

      var cur = base;
      var box = document.createElement('div');
      box.className = 'fhr__servings';
      box.innerHTML = '<span class="fhr__servings-label">Porsjoner</span>' +
        '<div class="fhr__servings-ctrl">' +
        '<button type="button" class="fhr__servings-btn" data-fhr-d="-1" aria-label="Færre porsjoner">−</button>' +
        '<output class="fhr__servings-n" aria-live="polite">' + cur + '</output>' +
        '<button type="button" class="fhr__servings-btn" data-fhr-d="1" aria-label="Flere porsjoner">+</button></div>';
      var h = ing.querySelector('h3, h4');
      if (h) h.insertAdjacentElement('afterend', box);
      else ing.insertBefore(box, ing.firstChild);
      var out = box.querySelector('.fhr__servings-n');

      function apply() {
        out.textContent = String(cur);
        var f = cur / base;
        Array.prototype.forEach.call(ul.querySelectorAll('.fhr__qty'), function (q) {
          var lo = parseFloat(q.getAttribute('data-lo'));
          var hiAttr = q.getAttribute('data-hi');
          var unit = q.getAttribute('data-unit') || '';
          var txt = fmt(lo * f, unit);
          if (hiAttr) txt += (q.getAttribute('data-sep') || '–') + fmt(parseFloat(hiAttr) * f, unit);
          q.textContent = txt;
        });
        card.classList.toggle('fhr__servings--scaled', cur !== base);
        if (pill) pill.textContent = 'Porsjoner: ' + cur;
      }
      box.addEventListener('click', function (ev) {
        var b = ev.target && ev.target.closest ? ev.target.closest('[data-fhr-d]') : null;
        if (!b) return;
        var next = cur + parseInt(b.getAttribute('data-fhr-d'), 10);
        if (next < 1 || next > 16) return;
        cur = next;
        apply();
      });
    });
  }

  function removeLink(a) {
    if (a.parentNode && a.parentNode.tagName === 'LI') a.parentNode.parentNode.removeChild(a.parentNode);
    else if (a.parentNode) a.parentNode.removeChild(a);
  }

  function chapters(root) {
    var body = root.querySelector('.fhr__body') || root.querySelector('.fhfb__wrap');
    if (!body) return;
    var h2s = body.querySelectorAll('h2');
    if (!h2s.length) return;
    // Landingssider (fhfb): chips bygges her fra h2 (maks 5, ikke CTA/kilder).
    var auto = root.hasAttribute('data-fhr-autochips') && root.querySelector('[data-fhr-chapters]');
    if (auto && !auto.children.length) {
      var made = 0;
      Array.prototype.forEach.call(h2s, function (h, i) {
        if (made >= 5) return;
        if (h.closest('.fhfb__cta, .fha__cta, .fhfb__sources, .fha__sources')) return;
        var t = (h.textContent || '').trim().split(':')[0].split(' - ')[0];
        if (t.length > 30) t = t.slice(0, 29).replace(/\s+\S*$/, '') + '\u2026';
        var a = document.createElement('a');
        a.className = 'fhr__chip';
        a.href = '#kap-' + (i + 1);
        a.setAttribute('data-fhr-kap', String(i + 1));
        a.textContent = t;
        auto.appendChild(a);
        made++;
      });
    }
    var map = {};
    var showNr = h2s.length >= 3;
    var nr = 0;
    Array.prototype.forEach.call(h2s, function (h, i) {
      var n = i + 1;
      if (!h.id) h.id = 'kap-' + n;
      map[n] = h;
      // Rom til sticky header + lokal nav naar man hopper til et kapittel.
      h.style.scrollMarginTop = 'calc(var(--fhr-nav-top, 0px) + 72px)';
      // Kapittelnummer-eyebrow (v2): kun paa lesekapitler, aldri i CTA/kilder.
      if (showNr && !h.closest('.fha__cta, .fhfb__cta, .fha__sources, .fhfb__sources')) {
        nr++;
        h.setAttribute('data-fhr-kapnr', (nr < 10 ? '0' : '') + nr);
      }
    });
    // Kapitler inne i CTA-panelet er ikke lesekapitler: fjern dem fra lista.
    Array.prototype.forEach.call(root.querySelectorAll('[data-fhr-kap]'), function (a) {
      var h = map[a.getAttribute('data-fhr-kap')];
      if (!h || h.closest('.fha__cta')) removeLink(a);
    });
    var active = null;
    function setActive(n) {
      if (active === n) return;
      active = n;
      Array.prototype.forEach.call(root.querySelectorAll('[data-fhr-kap]'), function (a) {
        var on = a.getAttribute('data-fhr-kap') === String(n);
        var cls = a.classList.contains('fhr__chip') ? 'fhr__chip--on' : 'fhr__toc--on';
        a.classList.toggle(cls, on);
        if (on && cls === 'fhr__chip--on' && a.scrollIntoView) {
          try { a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
        }
      });
    }
    // Aktivt kapittel = siste h2 som har passert 40 % av skjermen.
    var ticking = false;
    function spy() {
      ticking = false;
      var line = (window.innerHeight || 800) * 0.4;
      var cur = null;
      Array.prototype.forEach.call(h2s, function (h, i) {
        if (h.getBoundingClientRect().top <= line) cur = i + 1;
      });
      if (cur) setActive(cur);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  function faq(root) {
    var items = root.querySelectorAll('.fhr__body .fha__faq-item');
    if (!items.length) return;
    Array.prototype.forEach.call(items, function (item) {
      var q = item.querySelector('.fha__faq-q, .fha__faq-question');
      var a = item.querySelector('.fha__faq-a, .fha__faq-answer');
      if (!q || !a) return;
      var wrap = item.closest('.fha__faq') || item.parentNode;
      wrap.classList.add('fhr__faq-js');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fhr__faq-btn';
      btn.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span');
      label.textContent = q.textContent.trim();
      btn.appendChild(label);
      btn.insertAdjacentHTML('beforeend', '<svg class="fhi" aria-hidden="true"><use href="#fhi-plus"/></svg>');
      q.textContent = '';
      q.appendChild(btn);
      item.setAttribute('data-open', 'false');
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function tocMobile(root) {
    var toc = root.querySelector('[data-fhr-toc]');
    if (!toc) return;
    if (window.matchMedia && window.matchMedia('(max-width: 699px)').matches) toc.removeAttribute('open');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
